import PIXI from 'pixi.js/src';
import ball from './ball';
import data from './../data/data';
import GameStore from './../stores/GameStore';
// import audioHelper from './../helpers/audio';
import renderHelper from './../helpers/render';
import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';

const stephCurry = {
  stephWidth: 36,
  stephHeight: 107.5,
  stephBackHeight: 107.5,
  stephShotHeight: 136.5,
  touchStartPosition: 0,
  touchEndPosition: 0,
  speedCounter: 0,
  paused: false,
  animationTimeout: 0,
  swiping: false,
  swipeInterval: 0,
  swipeTime: 0,


  /**
   * Sets up Steph Curry
   * @returns {undefined} undefined
   */
  init() {
    const bodyEl = document.getElementsByTagName('BODY')[0];
    if (bodyEl.className.indexOf('ios') > -1) {
      this.ios = true;
    }

    if (bodyEl.className.indexOf('android') > -1) {
      this.android = true;
    }

    this.bodyContainer = new PIXI.Container();

    this.backSprite = new PIXI.Sprite(
      PIXI.loader.resources[data.curryPaths[0]].texture
    );
    this.backSprite.width = this.stephWidth;
    this.backSprite.height = this.stephBackHeight;
    this.bodyContainer.addChild(this.backSprite);

    this.shotSprite = new PIXI.Sprite(
      PIXI.loader.resources[data.curryPaths[1]].texture
    );
    this.shotSprite.width = this.stephWidth;
    this.shotSprite.height = this.stephShotHeight;
    this.bodyContainer.addChild(this.shotSprite);
    this.shotSprite.visible = false;

    renderHelper.stage.addChild(this.bodyContainer);
    this.bodyContainer.x = (window.innerWidth / 2) - (this.stephWidth / 2);
    this.bodyContainer.y = window.innerHeight - this.stephHeight;

    this.bodyContainer.interactive = true;
    this.touchStartListener = this.onTouchStart.bind(this);
    this.touchEndListener = this.onTouchEnd.bind(this);
    this.mouseDownListener = this.onMouseDown.bind(this);
    this.accelerometerListener = this.onAccelorometerChange.bind(this);
    this.resizeListener = this.onResize.bind(this);

    document.addEventListener('touchstart', this.touchStartListener);
    document.addEventListener('touchend', this.touchEndListener);
    this.bodyContainer.on('mousedown', this.mouseDownListener);
    window.addEventListener('devicemotion', this.accelerometerListener);
    this.resizeListener = this.onResize.bind(this);
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);
    this.gameStoreListener = this.onGameStoreChange.bind(this);
    GameStore.addChangeListener(this.gameStoreListener);

    this.positionGraphics();
  },


  /**
   * Positions Steph Curry
   * @returns {undefined} undefined
   */
  position(x, y) {
    this.bodyContainer.x = x;
    this.bodyContainer.y = y;
  },


  /**
   * Touch start handler
   * @returns {undefined} undefined
   */
  onTouchStart(e) {
    if (!this.paused) {
      this.touchStartPosition = e.changedTouches[0].clientY;
      this.swipeInterval = setInterval(this.incrementSwipeTime.bind(this), 1);
    }
  },


  /**
   * Increments the swipeTime var
   * @returns {undefined} undefined
   */
  incrementSwipeTime() {
    this.swipeTime++;
  },


  /**
   * Touch end handler
   * @returns {undefined} undefined
   */
  onTouchEnd(e) {
    if (!this.paused) {
      this.touchEndPosition = e.changedTouches[0].clientY;

      if (this.touchStartPosition > this.touchEndPosition) {
        // const distanceSwiped = this.touchStartPosition - this.touchEndPosition;
        // const velocity = distanceSwiped / this.swipeTime;
        let swipeTime = this.swipeTime;
        if (swipeTime > 130) {
          swipeTime = 130;
        }

        const velocity = ((130 - swipeTime) / 100);

        this.shootBall(velocity);
      }
    }

    clearInterval(this.swipeInterval);
    this.swipeTime = 0;
  },


  /**
   * Mouse down handler
   * @returns {undefined} undefined
   */
  onMouseDown(e) {
    this.touchEndPosition = e.clientY;
    this.shootBall();
  },


  /**
   * Fires an event to shoot a ball
   * @param {Number} velocity - The velocity to shoot the ball with
   * @returns {undefined} undefined
   */
  shootBall(velocity) {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.SHOOT_BALL,
      ballXPosition: (this.bodyContainer.x + (this.bodyContainer.width / 2)) - (ball.ballWidth / 2),
      ballVelocity: velocity,
    });

    this.showJump();

    // audioHelper.playSound('allsounds', 0.7, false, 1.1, 1.35);
  },

  showJump() {
    clearTimeout(this.animationTimeout);

    this.backSprite.visible = false;
    this.shotSprite.visible = true;

    setTimeout(this.showBack.bind(this), 200);
  },


  showBack() {
    this.backSprite.visible = true;
    this.shotSprite.visible = false;
  },


  /**
   * Called when a CHANGE event is emitted from the GameStore
   * @returns {undefined} undefined
   */
  onGameStoreChange() {
    const state = GameStore.getState();

    if (state.paused) {
      if (!this.paused) {
        this.paused = true;
      }
    } else {
      if (this.paused) {
        this.paused = false;
      }
    }
  },


  /**
   * Accelorometer handler
   * @returns {undefined} undefined
   */
  onAccelorometerChange(event) {
    if (!this.paused) {
      let xPos = event.accelerationIncludingGravity.x * 2.4;
      if (this.android) {
        xPos *= -1;
      }

      let newPos = this.bodyContainer.x + xPos;

      if (newPos < (this.stephWidth / 2)) {
        newPos = (this.stephWidth / 2);
      }

      if (newPos > (window.innerWidth) - this.stephWidth) {
        newPos = (window.innerWidth - this.stephWidth);
      }

      this.bodyContainer.x = newPos;
    }
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onResize() {
    this.positionGraphics();
  },


  /**
   * Positions graphics
   * @returns {undefined} undefined
   */
  positionGraphics() {
    this.bodyContainer.y = window.innerHeight - this.stephHeight;
  },


  /**
   * Destroys the basket
   * @returns {undefined} undefined
   */
  destroy() {
    document.removeEventListener('touchend', this.touchEndListener);
    window.removeEventListener('devicemotion', this.accelerometerListener);
    window.removeEventListener('resize', this.resizeListener);
    window.removeEventListener('orientationchange', this.resizeListener);

    this.bodyContainer.off('touchstart', this.touchStartListener);
    this.bodyContainer.off('mousedown', this.mouseDownListener);
    renderHelper.stage.removeChild(this.bodyContainer);
    this.bodyContainer = null;
    GameStore.removeChangeListener(this.gameStoreListener);
  },
};

export default stephCurry;



/** WEBPACK FOOTER **
 ** ./assets/js/src/graphics/steph-curry.js
 **/